import { createBrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import OrganizationPage from './pages/OrganizationPage';
import AchievementPage from './pages/AchievementPage';
import GroupPage from './pages/GroupPage';
import { generateDefaultScreenRoute } from './utils/route';

// Admin CMS imports
import { AdminLogin } from './admin/AdminLogin';
import { AdminLayout } from './admin/AdminLayout';
import { AdminDashboardOverview } from './admin/pages/AdminDashboardOverview';
import { NewsManager } from './admin/pages/NewsManager';
import { GalleryManager } from './admin/pages/GalleryManager';
import { OrgStructureManager } from './admin/pages/OrgStructureManager';
import { AchievementManager } from './admin/pages/AchievementManager';

function Root() {
  const location = useLocation();
  const defaultRoute = generateDefaultScreenRoute(
    parseInt(process.env.REACT_APP_DEFAULT_SCREEN || '1', 10)
  );

  return (
    <div key={location.pathname} className="animate-page-slide w-full min-h-screen">
      <Routes location={location}>
        {/* Admin Panel Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboardOverview />} />
          <Route path="news" element={<NewsManager />} />
          <Route path="gallery" element={<GalleryManager />} />
          <Route path="organization" element={<OrgStructureManager />} />
          <Route path="achievements" element={<AchievementManager />} />
        </Route>

        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/group/main" replace />} />
        <Route path="/group/:id" element={<GroupPage />} />
        <Route path="/gallery/:id" element={<GalleryPage />} />
        <Route path="/organization/:id" element={<OrganizationPage />} />
        <Route path="/achievement/:id" element={<AchievementPage />} />
        <Route path="/:id" element={<HomePage />} />
        <Route path="*" element={<Navigate to={defaultRoute} replace />} />
      </Routes>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: '*',
    Component: Root,
  },
]);

export default router;
